import http from "plugins/axios";

export default {
  getOrderList({ page, size, coin,   userId }) {
    return http.get({
      url: `/la/admin/finance/balance/list?page=${page}&size=${size}&coin=${coin}&userId=${userId}`,
    });
  },
  exportExcel({  coin, userId }){
    return http.get({
        url: `/la/admin/finance/balance/list/excel?coin=${coin}&userId=${userId}`,
        responseType:'blob',
    })
  },
  getFbsPairs(){
    return http.get({
      url:'admin/symbol/fbsNames' //更改后的路径
      // url:' /la/admin/pair/list'
    })
   },
   getAllCoins() {
    return http.get({
      url: '/la/admin/coin/coin-list'
    });
  },
};
